import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const CloseCircle: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M10.0001 2.29199C5.74289 2.29199 2.29175 5.74311 2.29175 10.0003C2.29175 14.2575 5.74289 17.7086 10.0001 17.7086C14.2573 17.7086 17.7084 14.2575 17.7084 10.0003C17.7084 5.74311 14.2573 2.29199 10.0001 2.29199ZM1.04175 10.0003C1.04175 5.05276 5.05253 1.04199 10.0001 1.04199C14.9476 1.04199 18.9584 5.05276 18.9584 10.0003C18.9584 14.9478 14.9476 18.9586 10.0001 18.9586C5.05253 18.9586 1.04175 14.9478 1.04175 10.0003ZM7.05814 7.05836C7.30222 6.81429 7.69795 6.81429 7.94202 7.05836L10.0001 9.11642L12.0581 7.05836C12.3022 6.81429 12.6979 6.81429 12.942 7.05836C13.1861 7.30244 13.1861 7.69817 12.942 7.94225L10.884 10.0003L12.942 12.0583C13.1861 12.3024 13.1861 12.6982 12.942 12.9422C12.6979 13.1863 12.3022 13.1863 12.0581 12.9422L10.0001 10.8842L7.94202 12.9422C7.69795 13.1863 7.30222 13.1863 7.05814 12.9422C6.81406 12.6982 6.81406 12.3024 7.05814 12.0583L9.1162 10.0003L7.05814 7.94225C6.81406 7.69817 6.81406 7.30244 7.05814 7.05836Z" fill="#667085" />
  </svg>
);

export default CloseCircle;
